export default "__VITE_ASSET__Dni1GVq8__"